import { useEffect, useState } from "react";

export function useLiveHHMMSSFrom(startMs?: number) {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    if (!Number.isFinite(startMs)) return; // no timer if missing
    const msToNext = 1000 - (Date.now() % 1000);
    let intervalId: number | undefined;

    const timeoutId = window.setTimeout(() => {
      setTick((t) => t + 1);
      intervalId = window.setInterval(() => setTick((t) => t + 1), 1000) as unknown as number;
    }, msToNext);

    return () => {
      window.clearTimeout(timeoutId);
      if (intervalId) window.clearInterval(intervalId);
    };
  }, [startMs]);

  if (!Number.isFinite(startMs)) return "-";

  const elapsed = Math.max(0, Date.now() - (startMs as number));
  const totalSec = Math.floor(elapsed / 1000);
  const hh = String(Math.floor(totalSec / 3600)).padStart(2, "0");
  const mm = String(Math.floor((totalSec % 3600) / 60)).padStart(2, "0");
  const ss = String(totalSec % 60).padStart(2, "0");
  return `${hh}:${mm}:${ss}`;
}
